import { PopoverDesignTokens } from '@primeuix/themes/types/popover';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/popover/index.ts
const pop = tDeep(componentCommon.popover);

export const PopoverTelekomDT: PopoverDesignTokens = {
  root: {
    background: pop.background,
    color: pop.color,
    borderRadius: pop.border.radius,
  },
  content: {
    padding: pop.content.padding,
  },
};
